import { useEffect, useState } from 'react';

const useWindowFocus = (callback: (focused: boolean) => void) => {
  useEffect(() => {
    const onFocus = () => callback(true);
    const onBlur = () => callback(false);

    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  }, [callback]);
};

export const useDidUserRefocusPage = (cb?: () => void) => {
  const [didUserUnfocusPage, setDidUserUnfocusPage] = useState(false);
  const [didUserFocusPage, setDidUserFocusPage] = useState(false);

  useWindowFocus((focused) => {
    if (focused) {
      setDidUserFocusPage(true);
    } else {
      setDidUserUnfocusPage(true);
    }
  });
  const didUserRefocusPage = didUserUnfocusPage && didUserFocusPage;
  const [didUserRefocusPageFrozen, setDidUserRefocusPageFrozen] =
    useState(didUserRefocusPage);

  // Reset the flags after 1.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (!didUserRefocusPage) return;
      setDidUserUnfocusPage(false);
      setDidUserFocusPage(false);
    }, 1500);

    if (didUserRefocusPage) {
      setDidUserRefocusPageFrozen(true);
      cb?.();
    }

    return () => clearInterval(interval);
    // we only want to run this effect when the user refocuses the page as we use
    // their focus status to update loading states
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [didUserRefocusPage]);

  return {
    didUserRefocusPage,
    didUserRefocusPageFrozen,
  };
};
